import { ReactNode } from 'react';
import { MarketButton } from '@market/react';

// if more MarketButton props are needed, we can add them here
// i.e. if we want to add href, target, variant, etc.
interface PrimaryProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
}

const Primary = ({
  children,
  className = '',
  onClick,
  disabled = false,
}: PrimaryProps) => {
  return (
    <MarketButton
      rank="primary"
      className={className}
      onClick={onClick}
      data-testid="cta-subnav-primary"
      disabled={disabled}
    >
      {children}
    </MarketButton>
  );
};

export default Primary;
